import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة استهلاك الوقود - احسب معدل استهلاك البنزين";
const DESCRIPTION =
  "تساعدك حاسبة تكلفة الوقود في حساب الكمية المطلوبة من الوقود وتقدير تكلفتها بدقة بناءً على المسافة التي تنوي قطعها وكفاءة استهلاك الوقود وسعر الوقود الحالي. استخدم هذه الأداة لتخطيط ميزانيتك لرحلتك القادمة بسهولة ويسر.";
const KEYWORDS =
  "حاسبة تكلفة الوقود, تكلفة الوقود, كمية الوقود المطلوبة, كفاءة الوقود, سعر الوقود, تخطيط الرحلات";
const OG_URL = "https://do-calculate.com/calculator/ar/fuel-cost-calculator";
function FuelCostCalculator() {
  const [distance, setDistance] = useState("");
  const [fuelEfficiency, setFuelEfficiency] = useState("");
  const [fuelPrice, setFuelPrice] = useState("");
  const [unitDistance, setUnitDistance] = useState("miles");
  const [unitEfficiency, setUnitEfficiency] = useState("mpg");
  const [unitPrice, setUnitPrice] = useState("per gallon");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const calculateFuelCost = () => {
    if (!distance || !fuelEfficiency || !fuelPrice) {
      setError("الرجاء إدخال جميع القيم بشكل صحيح");
      setResult("");
      return;
    }
    let distanceInMiles = parseFloat(distance);
    let efficiencyInMpg = parseFloat(fuelEfficiency);
    let pricePerGallon = parseFloat(fuelPrice);
    if (unitDistance === "km") {
      distanceInMiles = distanceInMiles * 0.621371;
    }
    if (unitEfficiency === "liters per 100 km") {
      efficiencyInMpg = 235.214583 / efficiencyInMpg;
    } else if (unitEfficiency === "kilometers per liter") {
      efficiencyInMpg = efficiencyInMpg * 2.35214583;
    } else if (unitEfficiency === "liter per mile") {
      efficiencyInMpg = 1 / (efficiencyInMpg * 0.264172);
    }
    if (unitPrice === "per liter") {
      pricePerGallon = pricePerGallon * 3.78541;
    }
    const gallonsRequired = distanceInMiles / efficiencyInMpg;
    const cost = gallonsRequired * pricePerGallon;
    setResult({
      gallonsRequired: gallonsRequired.toFixed(2),
      cost: cost.toFixed(2),
    });
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بك في حاسبة تكلفة الوقود! هذه الأداة الرائعة تساعدك في
                  حساب كمية الوقود المطلوبة وتكلفتها بدقة للرحلات المختلفة. سواء
                  كنت تخطط لرحلة طويلة عبر البلاد أو لمجرد رحلة قصيرة، فإن حاسبة
                  تكلفة الوقود توفر لك المعلومات التي تحتاجها لتخطيط ميزانيتك
                  بشكل فعال. باستخدام هذه الأداة، يمكنك بسهولة معرفة التكلفة
                  الإجمالية للوقود بناءً على المسافة، كفاءة استهلاك الوقود، وسعر
                  الوقود الحالي.
                </p>
                <p>لتستخدم الحاسبة بفعالية:</p>
                <ul>
                  <li>
                    ادخل المسافة التي تنوي قطعها، كفاءة استهلاك الوقود (كم/لتر)،
                    وسعر الوقود لكل وحدة.
                  </li>
                  <li>اختر الوحدات المناسبة لكل قيمة لضمان دقة الحسابات.</li>
                  <li>
                    اضغط على زر "احسب التكلفة" للحصول على تقدير دقيق لتكلفة
                    الوقود المطلوبة.
                  </li>
                  <li>
                    ستظهر النتيجة أسفل النموذج، مما يسهل عليك التخطيط للرحلة.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label ms-2">مسافة الرحلة</label>
                    </b>
                    <input
                      type="number"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                      className="form-control"
                      placeholder="أدخل المسافة"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitDistance}
                      onChange={(e) => setUnitDistance(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="miles">ميل</option>
                      <option value="km">كم</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">كفاءة الوقود</label>
                    </b>
                    <input
                      type="number"
                      value={fuelEfficiency}
                      onChange={(e) => setFuelEfficiency(e.target.value)}
                      className="form-control"
                      placeholder="أدخل الكفاءة"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitEfficiency}
                      onChange={(e) => setUnitEfficiency(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="mpg">ميل لكل جالون</option>
                      <option value="liters per 100 km">لتر لكل 100 كم</option>
                      <option value="kilometers per liter">كم لكل لتر</option>
                      <option value="liter per mile">لتر لكل ميل</option>
                    </select>
                  </div>
                  <div className="form-group d-flex align-items-center mt-2">
                    <b>
                      <label className="form-label ms-2">سعر الوقود</label>
                    </b>
                    <input
                      type="number"
                      value={fuelPrice}
                      onChange={(e) => setFuelPrice(e.target.value)}
                      className="form-control"
                      placeholder="أدخل السعر"
                      style={{ width: "75%", marginRight: "10px" }}
                    />
                    <select
                      value={unitPrice}
                      onChange={(e) => setUnitPrice(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="per gallon">لكل جالون</option>
                      <option value="per liter">لكل لتر</option>
                    </select>
                  </div>
                  <br />
                  <p className="alert alert-info">
                    <b>كفاءة الوقود: </b>
                    هو عدد الكيلومترات التي تقطعها سيارتك بلتر واحد من الوقود. يمكنك إيجاده في دليل السيارة، أو على لوحة القيادة، أو بحسابه بنفسك.
                  </p>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateFuelCost}
                  >
                    احسب                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      خطأ: {error}
                    </p>
                  ) : (
                    <>
                      { result && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            تكلفة الرحلة:
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            {result.gallonsRequired} جالون من الوقود
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            {result.cost} دولار
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                العوامل المؤثرة على استهلاك الوقود
              </h3>
            </div>
            <div className="info-section-body">
              <p>
                هناك العديد من العوامل التي يمكن أن تؤثر على استهلاك الوقود، بما
                في ذلك:
              </p>
              <ul>
                <li>نوع السيارة</li>
                <li>سرعة القيادة</li>
                <li>ظروف الطريق</li>
                <li>ضغط الإطارات</li>
                <li>حالة المحرك</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>توفير الوقود</h3>
            </div>
            <div className="info-section-body">
              <p>هناك العديد من الطرق لتوفير الوقود، بما في ذلك:</p>
              <ul>
                <li>قيادة اقتصادية</li>
                <li>مراقبة ضغط الإطارات</li>
                <li>الحفاظ على السيارة في حالة جيدة</li>
                <li>اختيار الوقود المناسب</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FuelCostCalculator;
